import styled from 'styled-components';
import { NftPriceSummary as NftPriceSummaryComponent } from 'components/Shared/NftPriceSummary';

export const CartHeaderNavigationStep = styled.span`
  color: var(--v3-text-color);
  font-size: 18px;
  font-weight: 600;
  line-height: 24px;
  letter-spacing: -0.54px;
  margin-right: auto;
`;

export const CartBodyWrapper = styled.div`
  padding: 32px 24px 16px;
  width: 100%;
  flex: 1;
  display: flex;
  flex-direction: column;
`;

export const CartBodyTitle = styled.div`
  color: var(--v3-text-color);
  text-align: center;
  font-size: 24px;
  font-style: normal;
  font-weight: 700;
  line-height: 32px;
  margin-bottom: 24px;
  letter-spacing: -0.48px;
`;

export const CartFooter = styled.div`
  position: sticky;
  bottom: 0;
  left: 0;
  right: 0;
  width: 100%;
  background: var(--v3-black-0);
  z-index: 1;
  padding: 16px 32px;
`;

export const NftPriceSummary = styled(NftPriceSummaryComponent)`
  margin-bottom: 24px;
  background: var(--v3-black-1);
  padding: 20px;
  border-radius: 16px;
`;
